<template>
    <div class="row">
        <snappy-table
                :endpoint="'vessels/' + vesselId + '/audiences'"
                :columns="['name','contacts_count','campaigns_count']"
                :headings="['Group','Contacts','Campaigns']"
                :handle-row-click="onRowClick"
                :templated-slot-names="['name']"
                record-type="Groups"
        >
            <template #name="{ row }">
                {{ row.name }}
              <span class="label label-id">ID: {{ row.id }}</span>
              <span v-if="row.is_default" class="label label-id">DEFAULT</span>
            </template>
        </snappy-table>
    </div>
</template>

<script>
    import SnappyTable from '../../components/SnappyTable';
    import axios from 'axios';

    export default {
        name: 'group-listing-table',
        components: {SnappyTable},
        data() {
            return {

            };
        },
        methods: {
            onRowClick(event) {
                window.location.href = '/inventory/contacts/groups/edit/?sk_token=' + this.groupToken(event.row.id);
            },
            groupToken: function(groupId) {
                return btoa('group_id=' + groupId);
            }
        },
        props: {
            vesselId: {
                type: Number,
                required: true
            }
        }
    }
</script>